import React, { Component } from 'react';
import PropTypes from 'prop-types';

import NotFound404Light from './images/light/404.png';
import ApiErrorLight from './images/light/api_error.png';
import ComingSoonLight from './images/light/coming_soon.png';
import DeletedDefaultLight from './images/light/deleted_default.png';
import EmptyDefaultLight from './images/light/empty_default.png';
import NetworkErrorLight from './images/light/network_error.png';
import NoPermissionDefaultLight from './images/light/no_permission_default.png';
import UpdateLight from './images/light/update.png';

import './index.less';

const ImageSrcList = {
	no_permission_default: NoPermissionDefaultLight,
	'404': NotFound404Light,
	coming_soon: ComingSoonLight,
	deleted: DeletedDefaultLight,
	empty_default: EmptyDefaultLight,
	network_error: NetworkErrorLight,
	update: UpdateLight,
	api_error: ApiErrorLight,
};

/**
 * 空白页
 */
class Blank extends Component {
	constructor (props) {
		super(props);

		this.state = {};
	}

	static propTypes = {
		height: PropTypes.string, //需要加上px
		title: PropTypes.string,
		content: PropTypes.string,
		btnText: PropTypes.string,
		image: PropTypes.string,
		clickBtn: PropTypes.func,
		imageType: PropTypes.oneOf([
			'404',
			'api_error',
			'coming_soon',
			'deleted_default',
			'empty_default',
			'network_error',
			'no_permission_default',
			'update',
		]),
	};

	static defaultProps = {
		layout: 'column', //column:纵向；row:横向
		height: '100%',
		title: '',
		content: '',
		btnText: '',
		image: '',
		imageType: 'empty_default',
	};

	onClickBtn = () => {
		const { clickBtn } = this.props;

		if (clickBtn) {
			clickBtn();
		}
	};

	render () {
		const prefixCls = 'eh-blank';
		const {
			layout,
			// height,
			title,
			content,
			btnText,
			image,
			imageType,
		} = this.props;

		return (
			// style={{ height }}
			<div className={`${prefixCls} ${layout === 'column' ? 'eh-blank2' : 'eh-blank1'}`} >
				{layout === 'column' && <div className={`${prefixCls}-container`}>
					<div className={`${prefixCls}-container-image`}>
						<img src={image || ImageSrcList[`${imageType}`]} alt="blankPage-icon" />
					</div>

					{content && <div className={`${prefixCls}-container-title`}>{content}</div>}
					{/* {content && <div className={`${prefixCls}-container-txt`}>{content}</div>} */}

					{btnText && (
						<div className={`${prefixCls}-container-btn`}>
							<a
								style={{
									border: 'none',
								}}
								className={`${prefixCls}-button ${prefixCls}-button-primary`}
								onClick={this.onClickBtn}
							>
								<span>{btnText}</span>
							</a>
						</div>
					)}
				</div>}
				{layout === 'row' && <div className={`${prefixCls}-container`}>
					<div className={`${prefixCls}-container-content`}>
						<img src={image || ImageSrcList[`${imageType}`]} alt="blankPage-icon" />

						<div className={`${prefixCls}-container-right`}>
							{title && <div className={`${prefixCls}-container-title row-title`}>{title}</div>}
							{content && <div className={`${prefixCls}-container-txt row-txt`}>{content}</div>}

							{btnText && (
								<div className={`${prefixCls}-container-btn`} style={{textAlign: 'left'}}>
									<a
										style={{
											border: 'none',
										}}
										className={`${prefixCls}-button row-button ${prefixCls}-button-primary`}
										onClick={this.onClickBtn}
									>
										<span>{btnText}</span>
									</a>
								</div>
							)}
						</div>
					</div>
				</div>}
			</div>
		);
	}
}

export default Blank;
